module.exports = __webpack_public_path__ + "media/msg_incoming.9a08260a.mp3";